import { render, staticRenderFns } from "./EventChallenge.vue?vue&type=template&id=bf031f20&"
import script from "./EventChallenge.vue?vue&type=script&lang=js&"
export * from "./EventChallenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports